import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import usePermissions from '../../hooks/usePermissions';

const ProtectedRoute = ({
  children,
  requiredModule,
  requiredAnyModules,
  requiredAllModules,
  requiredPermission,
}) => {
  const { isAuthenticated } = useAuth();
  const { hasModule, hasAnyModule, hasAllModules, permissions, isAdmin } = usePermissions();

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  const canAccess =
    isAdmin()
    || (
      (!requiredModule || hasModule(requiredModule))
      && (!requiredAnyModules || hasAnyModule(requiredAnyModules))
      && (!requiredAllModules || hasAllModules(requiredAllModules))
      && (!requiredPermission || permissions[requiredPermission])
    );

  if (!canAccess) {
    return <Navigate to="/home" replace />;
  }
  
  return children;
};

export default ProtectedRoute;
